/**
 * Bridges offline writes from services into SyncContext's queueChange when available.
 */
import { syncQueueDb, type QueuedChange } from '@/lib/db';

type QueueFn = (change: Omit<QueuedChange, 'id' | 'attempts' | 'createdAt'>) => Promise<void>;

let queueHandler: QueueFn | null = null;

export function setOfflineQueueHandler(handler: QueueFn | null): void {
  queueHandler = handler;
}

export async function queueOfflineChange(
  change: Omit<QueuedChange, 'id' | 'attempts' | 'createdAt'>
): Promise<void> {
  if (queueHandler) {
    await queueHandler(change);
    return;
  }
  await syncQueueDb.add({
    ...change,
    attempts: 0,
    createdAt: new Date().toISOString(),
  });
}

/** Prefer Dexie when offline or when only locally unlocked (no access token). */
export function shouldUseLocalData(hasAccessToken: boolean): boolean {
  if (!navigator.onLine) return true;
  if (!hasAccessToken) return true;
  return false;
}
